export default __webpack_public_path__ + "static/media/avatar-thumb-1.505d2c8a.png";